
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSOrderBOMGrid extends Serenity.EntityGrid<POSOrderBOMRow, any> {
        protected getColumnsKey() { return 'Retail.OrderBOM'; }
        protected getDialogType() { return POSOrderBOMDialog; }
        protected getIdProperty() { return POSOrderBOMRow.idProperty; }
        protected getInsertPermission() { return POSOrderBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return POSOrderBOMRow.localTextPrefix; }
        protected getService() { return POSOrderBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}